import { render, staticRenderFns } from "./JoinGroup.vue?vue&type=template&id=0534a0f4&scoped=true"
import script from "./JoinGroup.vue?vue&type=script&lang=js"
export * from "./JoinGroup.vue?vue&type=script&lang=js"
import style0 from "./JoinGroup.vue?vue&type=style&index=0&id=0534a0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0534a0f4",
  null
  
)

export default component.exports